"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utf8Substring = exports.utf8Length = void 0;
var tslib_1 = require("tslib");
function utf8Length(str) {
    return tslib_1.__spread(str).length;
}
exports.utf8Length = utf8Length;
function utf8Substring(str, start, end) {
    return tslib_1.__spread(str).slice(start, end).join('');
}
exports.utf8Substring = utf8Substring;
//# sourceMappingURL=utf8.js.map